module.exports = __webpack_public_path__ + "static/img/ServiceInspection.a497020.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/image/ServiceInspection.png
// module id = +pwj
// module chunks = 1